import { render, staticRenderFns } from "./linkYuu.vue?vue&type=template&id=39b40d4b&scoped=true&"
import script from "./linkYuu.vue?vue&type=script&lang=js&"
export * from "./linkYuu.vue?vue&type=script&lang=js&"
import style0 from "./linkYuu.vue?vue&type=style&index=0&id=39b40d4b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b40d4b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
